import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';
import { frCA } from './fr-CA/index';

export const userAccountTranslations: TranslationResources = {
  en,
  fr_CA: frCA,
};

export const userAccountTranslationChunksConfig: TranslationChunksConfig = {
  userAccount: ['loginForm', 'miniLogin', 'authMessages'],
  userRegister: ['register'],
};
